import React, { useEffect, useRef, useState } from 'react';
import { Feature, Map, View } from 'ol';
import { useDispatch, useSelector } from 'react-redux';
import { getProfile } from '../../reducer/profileSlice';
import TileLayer from 'ol/layer/Tile';
import Image from 'ol/layer/Image';
import XYZ from 'ol/source/XYZ';
import ImageWMS from 'ol/source/ImageWMS';
import { getAreaLevel } from '../../reducer/areaLevelSlice';
import { getWeekOfYear } from '../../reducer/weekOfYearSlice';
import { getAreaSelected } from '../../reducer/areaSelectedSlice';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { Card, CardContent, CardHeader, Divider, FormControlLabel, FormGroup, Grid, IconButton, Switch, Typography } from '@mui/material';
import SquareIcon from '@mui/icons-material/Square';
import { getMapDataSelected, setMapDataSelected } from '../../reducer/mapDataSelectedSlice';
import VectorSource from 'ol/source/Vector';
import VectorImageLayer from 'ol/layer/VectorImage';
import Style from 'ol/style/Style';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import GeoJSON from 'ol/format/GeoJSON';
import { defaults as defaultControls } from 'ol/control';

let wmsList = {
    qualify: undefined,
    active: undefined,
    unactive: undefined
};

const legendList = process.env.REACT_APP_ENABLE_FULL_FUNCTION === "true" ? [
    {
        icon: (
            <SquareIcon sx={{
                color: '#cd6c4a',
                backgroundColor: '#cd6c4a'
            }} />
        ),
        label: 'เปิด EOC'
    }, {
        icon: (
            <SquareIcon sx={{
                color: '#3fc380',
                backgroundColor: '#3fc380'
            }} />
        ),
        label: 'กิจกรรมตอบโต้'
    }, {
        icon: (
            <SquareIcon sx={{
                color: 'rgba(255, 255, 255, 1)',
                backgroundColor: '#1151a4'
            }} />
        ),
        label: 'เข้าเกณฑ์เปิด EOC'
    }
] : [{
    icon: (
        <SquareIcon sx={{
            color: 'rgba(255, 255, 255, 1)',
            backgroundColor: '#1151a4'
        }} />
    ),
    label: 'เข้าเกณฑ์เปิด EOC'
}]

function MonitorMap(props) {
    // const { monitorSelected } = props;
    const dispatch = useDispatch();
    const { eocqualify, eocactive, eocunactive } = props;
    const profile = useSelector(getProfile);
    const level = useSelector(getAreaLevel);
    const woy = useSelector(getWeekOfYear);
    const mapDataSelected = useSelector(getMapDataSelected);
    const areaSelected = useSelector(getAreaSelected);
    const [map, setMap] = useState();
    const mapRef = useRef();
    // const [layers, setLayers] = useState({});
    const [borderLayer, setBorderLayer] = useState();
    const [qualifyLayer, setQualifyLayer] = useState();
    const [activeLayer, setActiveLayer] = useState();
    const [unactiveLayer, setUnactiveLayer] = useState();
    const [selectedLayer, setSelectedLayer] = useState();
    const [blurLayer, setBlurLayer] = useState();
    const [areaNameLayer, setAreaNameLayer] = useState();
    const [openLegend, setOpenLegend] = useState(false);
    const [openSetting, setOpenSetting] = useState(false);
    const [mapSettingHighlight, setMapSettingHighlight] = useState(true);
    const [mapSettingAreaName, setMapSettingAreaName] = useState(true);
    // const layer = use

    const getWMS = (layerName, index, filter, wmsName) => {
        var params = {
            'QUERY_LAYERS': 'tanrabad:' + layerName,
            'LAYERS': 'tanrabad:' + layerName,
            // transparent: true,
            // format: "image/png",
            // '%20palette': 'safe'
        }
        // if (styled) {
        //     // params["STYLES"] = styled;
        //     params["STYLES"] = styled;
        // }
        if (filter) {
            params.cql_filter = filter;
        }
        // console.log(params);
        let source = new ImageWMS({
            // url: 'https://covid-ddc2.bigstream.cloud/geoserver/tanrabad/wms',
            url: 'https://trb-platform.ddc.moph.go.th/geoserver/tanrabad/wms',
            params: params,
            serverType: 'geoserver',
            crossOrigin: 'anonymous'
        })
        // console.log(source);
        if (wmsName) {
            wmsList[wmsName] = source;
        }
        var layer = new Image({
            properties: {
                layerName: layerName
            },
            // source: new ImageWMS({
            //     url: 'https://covid-ddc2.bigstream.cloud/geoserver/tanrabad/wms',
            //     params: params,
            //     serverType: 'geoserver',
            //     crossOrigin: 'anonymous'
            // }),
            source: source
        });

        map.addLayer(layer);
        layer.setZIndex(index);
        return layer;
    }

    useEffect(() => {
        if (map !== undefined) {
            if (borderLayer) {
                const attr = borderLayer.getProperties();
                if (level !== attr.layerName) {
                    // removeDataOnMap("border");
                    map.getLayers().remove(borderLayer);
                    let params = undefined;
                    if (level === 'region') {
                        params = 'health_region_type_id=4';
                    }
                    const layer = getWMS(`${level}`, 5, params);
                    setBorderLayer(layer);
                }
            } else {
                const layer = getWMS(`${level}`, 5, undefined);
                setBorderLayer(layer);
            }

            if (areaNameLayer) {
                map.getLayers().remove(areaNameLayer);
            }
            let wmsName = `${level}_name`;
            let filter = undefined;
            if (level === "region") {
                filter = 'health_region_type_id=4';
            }
            const layerAreaName = getWMS(wmsName, 900, filter);
            layerAreaName.setVisible(mapSettingAreaName);
            setAreaNameLayer(layerAreaName);
        }
    }, [map, level])

    useEffect(() => {
        if (map !== undefined) {
            if (selectedLayer) {
                map.getLayers().remove(selectedLayer);
            }
            if (mapDataSelected.length > 0) {
                let vectorSource = new VectorSource();
                for (let index = 0; index < mapDataSelected.length; index++) {
                    const element = mapDataSelected[index];
                    let feature;
                    let style = new Style({
                        fill: new Fill({
                            color: `#cd6c4a00`
                        }),
                        stroke: new Stroke({
                            color: '#1151a4',
                            width: 5
                        }),
                    });
                    let f = new GeoJSON({
                        dataProjection: 'EPSG:4326',
                    });
                    let geom = f.readGeometry(element.geometry);

                    feature = new Feature({
                        geometry: geom,
                        id: element.id
                    });
                    feature.setStyle(style);
                    vectorSource.addFeature(feature);
                }
                let vectorLayer = new VectorImageLayer({
                    source: vectorSource
                })
                map.addLayer(vectorLayer);
                vectorLayer.setZIndex(20);

                setSelectedLayer(vectorLayer);
            }
        }
    }, [map, mapDataSelected])

    useEffect(() => {
        // console.log(map);
        // console.log(eocqualify);
        if (map !== undefined) {
            if (eocqualify) {
                if (qualifyLayer) {
                    map.getLayers().remove(qualifyLayer);
                }
                // console.log(level);
                const layer = getWMS(`${level}_eoc_qualify_new`, 10, `eoc_week=${woy.week} AND year=${woy.year}`, 'qualify');
                setQualifyLayer(layer);
            } else {
                if (qualifyLayer) {
                    wmsList['qualify'] = undefined;
                    map.getLayers().remove(qualifyLayer);
                }
            }
        }
    }, [map, eocqualify, level, woy])

    useEffect(() => {
        if (map !== undefined) {
            if (eocactive) {
                if (activeLayer) {
                    map.getLayers().remove(activeLayer);
                }
                let week = woy.week;
                if (week < 10) {
                    week = `0${week}`
                }
                let time = `${woy.year}${week}`;
                let params = `start<=${time} AND end>=${time} AND status=true`;
                if (level !== 'tambon') {
                    const layer = getWMS(`${level}_eoc_active_new`, 8, params, 'active');
                    setActiveLayer(layer);
                }
            } else {
                if (activeLayer) {
                    wmsList['active'] = undefined;
                    map.getLayers().remove(activeLayer);
                }
            }
        }
    }, [map, eocactive, level, woy])

    useEffect(() => {
        if (map !== undefined) {
            if (eocunactive) {
                if (unactiveLayer) {
                    map.getLayers().remove(unactiveLayer);
                }
                let week = woy.week;
                if (week < 10) {
                    week = `0${week}`
                }
                let time = `${woy.year}${week}`;
                // let params = `start<=${time} AND end>=${time} AND status=false`;
                let params = `start=${time} AND status=false`;
                if (level !== 'tambon') {
                    const layer = getWMS(`${level}_eoc_active_new`, 8, params, 'unactive');
                    setUnactiveLayer(layer);
                }
            } else {
                if (unactiveLayer) {
                    wmsList['unactive'] = undefined;
                    map.getLayers().remove(unactiveLayer);
                }
            }
        }
    }, [map, eocunactive, level, woy])

    useEffect(() => {
        if (map !== undefined) {
            if (blurLayer) {
                map.getLayers().remove(blurLayer);
            }
            if (areaSelected.level !== 1) {
                let layerBlur = "tambon_blur";
                let filter = `tambon_code<>${areaSelected.value}`;
                if (areaSelected.level === 2) {
                    layerBlur = "health_region_blur";
                    filter = `health_region_type_id = 4 AND health_region_code <> '${areaSelected.value}'`;
                } else if (areaSelected.level === 3) {
                    layerBlur = "province_blur";
                    filter = `prov_code <> '${areaSelected.value}'`;
                } else if (areaSelected.level === 4) {
                    layerBlur = "amphur_blur";
                    filter = `amp_code <> '${areaSelected.value}'`;
                }
                const layerBlurWMS = getWMS(layerBlur, 999, filter);
                layerBlurWMS.setVisible(mapSettingHighlight)
                setBlurLayer(layerBlurWMS);
            }
            map.getView().fit(areaSelected.bbox, {
                size: map.getSize(),
                nearest: true
            })
        }
    }, [areaSelected, map])

    useEffect(() => {
        if (profile !== undefined && profile !== null) {
            if (map === undefined) {
                const initialMap = new Map({
                    target: mapRef.current,
                    layers: [
                        new TileLayer({
                            source: new XYZ({
                                // url: 'https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}',
                                // url: `https://api.maptiler.com/maps/basic-v2/{z}/{x}/{y}.png?key=lH2JW9wBgx5zp3xfRC3J`,
                                url: `https://tile.openstreetmap.org/{z}/{x}/{y}.png`
                            })
                        })
                    ],
                    view: new View({
                        projection: 'EPSG:4326',
                        center: [100.523186, 13.736717],
                        zoom: 10
                    }),
                    controls: defaultControls({
                        attribution: false
                    })
                })

                initialMap.on('click', async function (evt) {
                    let viewResolution = initialMap.getView().getResolution();
                    // console.log(viewResolution);
                    let featureList = [];
                    for (const key in wmsList) {
                        if (Object.hasOwnProperty.call(wmsList, key)) {
                            const value = wmsList[key];
                            if (value) {
                                const url = value.getFeatureInfoUrl(
                                    evt.coordinate,
                                    viewResolution,
                                    'EPSG:4326',
                                    { 'INFO_FORMAT': 'application/json' }
                                );
                                if (url) {
                                    const response = await fetch(url);
                                    const data = await response.json();
                                    const features = data.features;
                                    if (features.length > 0) {
                                        featureList.push(...features)
                                    }
                                }
                            }
                        }
                    }
                    dispatch(setMapDataSelected(featureList))
                });
                setMap(initialMap)
            }
        }
    }, [profile, map])

    useEffect(() => {
        if (areaNameLayer !== undefined) {
            areaNameLayer.setVisible(mapSettingAreaName)
        }
    }, [mapSettingAreaName])

    useEffect(() => {
        if (blurLayer !== undefined) {
            blurLayer.setVisible(mapSettingHighlight)
        }
    }, [mapSettingHighlight])

    return (
        <div ref={mapRef} style={{
            width: '100%',
            height: '100%',
            position: 'relative'
        }}>
            <Card sx={{
                position: 'absolute',
                left: 10,
                bottom: 10,
                width: 250,
                backgroundColor: 'white',
                zIndex: 10
            }}>
                <CardHeader
                    title="คำอธิบายสัญลักษณ์"
                    action={
                        <IconButton
                            aria-label="ขยาย"
                            onClick={() => {
                                setOpenLegend(!openLegend);
                            }}
                        >
                            {
                                !openLegend ? <ExpandLessIcon /> : <ExpandMoreIcon />
                            }
                        </IconButton>
                    }
                    sx={(theme) => ({
                        '& .MuiCardHeader-title': {
                            fontSize: '14px',
                            textAlign: 'left',
                            fontWeight: '400',
                        },
                        '&.MuiCardHeader-root': {
                            paddingTop: '5px',
                            paddingBottom: '5px'
                        }
                    })}
                />
                {
                    openLegend ?
                        <>
                            <Divider />
                            <CardContent sx={(theme) => ({
                                '&.MuiCardContent-root': {
                                    paddingBottom: '10px',
                                    paddingTop: '10px',
                                    maxHeight: '300px',
                                    overflow: 'auto',
                                }
                            })}>
                                <Grid container spacing={1}>
                                    {
                                        legendList.map((data, index) => {
                                            return (
                                                <Grid key={index} container item xs={12}>
                                                    <Grid item xs={3} sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                        {/* <img alt="candice" src={`/images/markers/${data.icon}`} /> */}
                                                        {data.icon}
                                                    </Grid>
                                                    <Grid item xs={9}>
                                                        <Typography sx={{
                                                            fontSize: 14,
                                                            paddingLeft: '5px',
                                                            textAlign: 'left',
                                                            marginTop: '5px',
                                                            fontWeight: '400',
                                                        }}>
                                                            {data.label}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            )
                                        })
                                    }
                                </Grid>
                            </CardContent>
                        </> : <></>
                }
            </Card>

            <Card sx={{
                position: 'absolute',
                right: 10,
                bottom: 10,
                backgroundColor: 'white',
                zIndex: 10
            }}>
                <CardHeader
                    title="ตั้งค่า"
                    action={
                        <IconButton
                            aria-label="ขยาย"
                            onClick={() => {
                                setOpenSetting(!openSetting);
                            }}
                        >
                            {
                                !openSetting ? <ExpandLessIcon /> : <ExpandMoreIcon />
                            }
                        </IconButton>
                    }
                    sx={(theme) => ({
                        '& .MuiCardHeader-title': {
                            fontSize: '14px',
                            textAlign: 'left',
                            fontWeight: '400',
                        },
                        '&.MuiCardHeader-root': {
                            paddingTop: '5px',
                            paddingBottom: '5px'
                        }
                    })}
                />
                {
                    openSetting ?
                        <>
                            <Divider />
                            <CardContent sx={(theme) => ({
                                '&.MuiCardContent-root': {
                                    paddingBottom: '10px',
                                    paddingTop: '10px',
                                    maxHeight: '300px',
                                    overflow: 'auto',
                                }
                            })}>
                                <FormGroup>
                                    <FormControlLabel
                                        // sx={(theme) => ({
                                        //     '& .MuiFormControlLabel-label': {
                                        //         fontSize: '14px'
                                        //     }
                                        // })}
                                        control={
                                            <Switch checked={mapSettingHighlight} onChange={(event) => {
                                                setMapSettingHighlight(event.target.checked);
                                                // dispatch(setMapSettingHighlight(event.target.checked))
                                            }} />
                                        }
                                        label="Highlight"
                                    />
                                    <FormControlLabel
                                        // sx={(theme) => ({
                                        //     '& .MuiFormControlLabel-label': {
                                        //         fontSize: '14px'
                                        //     }
                                        // })}
                                        control={
                                            <Switch checked={mapSettingAreaName} onChange={(event) => {
                                                setMapSettingAreaName(event.target.checked);
                                                // dispatch(setMapSettingAreaName(event.target.checked))
                                            }} />
                                        }
                                        label="ชื่อพื้นที่"
                                    />
                                </FormGroup>
                            </CardContent>
                        </> : <></>
                }
            </Card>
        </div>

    )
}

export default MonitorMap
